<form [formGroup]="filterFormGroup" class="list-work-order-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>My Work Orders</h3>
    </div>
    @if (isRoleManager || isRoleTTLApprover) {
      <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
        <app-approval-all-search
          class="search-bar"
          [selectedTabVal]="selectedTabVal"
          [workOrderSearchTextForm]="filterFormGroup.controls.workOrderSearchTextForm"></app-approval-all-search>
      </div>
    } @else {
      <div class="pure-u-md-14-24 pure-u-lg-10-24 right"></div>
    }
  </div>
  @if (isRoleManager) {
    <app-approval-l3-header [filterFormGroup]="filterFormGroup" (tabVal)="tabVal($event)"></app-approval-l3-header>
  } @else if (isRoleTTLApprover) {
    <app-manual-approval-ttl-my-wo [filterFormGroup]="filterFormGroup"></app-manual-approval-ttl-my-wo>
  } @else {
    <app-filter-dropdowns
      [loadedData]="loadedData"
      [loadedFormData]="loadedFormData"
      (getLoadedData)="getLoadedData($event)"
      (getLoadedFormData)="getLoadedFormData($event)"></app-filter-dropdowns>
  }
</form>
